import { EPlanName } from '@albacross/types'

// Not the frontend's PLANS_PRINTABLE_NAMES: that map is customer-facing and hides the PLG/SLG split.
export const PLAN_LABELS: Record<EPlanName, string> = {
  [EPlanName.Appsumo]: 'AppSumo',
  [EPlanName.Business]: 'Business',
  [EPlanName.Enterprise]: 'Enterprise',
  [EPlanName.Free]: 'Free',
  [EPlanName.FreeUS]: 'Free US',
  [EPlanName.Premium]: 'Premium',
  [EPlanName.Pro]: 'Pro',
  [EPlanName.Starter]: 'Starter',
  [EPlanName.SelfService99]: 'Self Service 99€',
  [EPlanName.TrialEnded]: 'Trial ended',
  [EPlanName.NoAccess]: 'No access',
  [EPlanName.SelfService]: 'Self Service',
  [EPlanName.Agency]: 'Agency',
  [EPlanName.PlgStarter]: 'PLG Starter',
  [EPlanName.PlgProfessional]: 'PLG Professional',
  [EPlanName.SlgStarter]: 'SLG Starter',
  [EPlanName.SlgProfessional]: 'SLG Professional',
  [EPlanName.SlgOrganisation]: 'SLG Organisation',
  [EPlanName.Api]: 'API',
}

// Plans exist in production that never passed through this repo, so an unknown name shows itself.
export const planLabel = (name?: string) => (name ? (PLAN_LABELS[name as EPlanName] ?? name) : undefined)
